/**
 * Whether or not to show the new email preference page
 */ export var NEW_EMAIL_UNSUBSCRIBE_PREFERENCE_PAGE_241104 = 'NEW_EMAIL_UNSUBSCRIBE_PREFERENCE_PAGE_241104';
